module.exports = __webpack_public_path__ + "static/media/centric.e357f720.png";